<template>
  <vxe-modal v-model="dialogVisible" show-zoom resize width="1200px" :title="title" esc-closable>
    <div style="text-align: left;width: 1100px;">
      <vxe-grid
        border="full"
        show-overflow
        ref="tableRef"
        v-bind="gridOptions"
        :data="tableData"
        align="right"
      >
        <template #asset="{ row,column }">
          <span :style="{color:(row[column.field]>=0 ? 'red':'green')}">{{row[column.field]?.toFixed(8)}}</span>
        </template>
        <template #number4="{ row,column }">
          {{row[column.field]?.toFixed(4)}}
        </template>
        <template #number="{ row,column }">
          {{row[column.field]?.toFixed(2)}}
        </template>
        <template #profit="{ row }">
          <span :style="{color:(row['usdValue']>row['costUsdt'] ? 'red':'green')}">
            {{(row['usdValue']-row['costUsdt']).toFixed(2)}}
          </span>
        </template>
        <template #increase="{ row,column }">
          <span :style="{color:(row[column.field]>0 ? 'red':'green')}">
            {{row[column.field]?.toFixed(2)}}%
          </span>
        </template>
      </vxe-grid>
    </div>
  </vxe-modal>
</template>

<script lang="ts">
import { defineComponent, onMounted, onUnmounted, ref } from "vue";
import { VxeGridProps, VxeTableInstance } from "vxe-table";
import rest from "@/rest";
import { ElMessage } from "element-plus";
import dayjs from "dayjs";

const gridOptions:VxeGridProps<Record<string, any>> = ({
  height: "800",
  columnConfig: { resizable: true },
  rowConfig: { isHover: true, height: 40 },
  columns: [
    { type: "seq", width: 40 },
    { field: "day", title: "日期", width: 160 },
    { field: "balanceBtc", title: "BTC余额", width: 120, slots: { default: "number4" } },
    { field: "balanceEth", title: "ETH余额", width: 120, slots: { default: "number4" } },
    { field: "balanceUsdt", title: "USDT余额", width: 120, slots: { default: "number" } },
    { field: "usdValue", title: "价值", width: 100, slots: { default: "number" } },
    { field: "costUsdt", title: "成本", width: 100, slots: { default: "number" } },
    { field: "profit", title: "利润", width: 100, slots: { default: "profit" } },
    { field: "increase", title: "总增长", width: 80, slots: { default: "increase" } },
    { field: "increaseDay", title: "日增长", width: 80, slots: { default: "increase" } }
  ]
});

export default defineComponent({
  computed: {
  },
  components: { },
  emits: [],
  expose: ["loadData"],
  setup () {
    const tableRef = ref<VxeTableInstance<Record<string, any>>>();
    const tableData = ref<Record<string, any>[]>([]);
    const tacticsIdRef = ref<number>(0);
    const dialogVisible = ref<boolean>(false);
    const title = ref<string>("");
    const loadData = (tacticsId:number) => {
      tacticsIdRef.value = tacticsId;
      title.value = `【 ${tacticsId} 号 】历史记录详情`;
      dialogVisible.value = true;
      rest.baFutureData({ action: "HISTORY", data: { tacticsId } }, (res:any) => {
        if (res) {
          tableData.value = res;
        } else {
          tableData.value = [];
        }
      });
    };

    return {
      tableRef,
      tableData,
      gridOptions,
      loadData,
      dialogVisible,
      title,
      dayjs
    };
  }
});
</script>

<style scoped></style>
